import { render, staticRenderFns } from "./PictureDeprecated.vue?vue&type=template&id=65cab7a0&scoped=true&"
import script from "./PictureDeprecated.vue?vue&type=script&lang=js&"
export * from "./PictureDeprecated.vue?vue&type=script&lang=js&"
import style0 from "./PictureDeprecated.vue?vue&type=style&index=0&id=65cab7a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cab7a0",
  null
  
)

export default component.exports